import styled from 'styled-components';

import { colors } from 'styles/colors';

const textMain = colors.text['main-900'];
const textSub = colors.text['sub-500'];
const primaryLight = colors.brand.primary.lighter;

export const IdleWrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
`;

export const IdleIconWrap = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: ${primaryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const IdleContent = styled.div`
  flex: 1;
  min-width: 240px;
`;

export const IdleTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: ${textMain};
  margin-bottom: 4px;
`;

export const IdleDesc = styled.div`
  font-size: 12px;
  color: ${textSub};
  line-height: 1.55;
  max-width: 480px;
`;

export const BetaBadge = styled.span`
  font-size: 9px;
  font-weight: 700;
  background: #3CCD86;
  color: #0B0C59;
  padding: 2px 7px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;
